import apiFetch from '../apiFetch'

export default function (values) {	
	if (values.tipoAnalisis !== 4) {//Si no es Magavision M
		apiFetch({server: 'oldMagavision', endPoint: 'crear_datos_peticion', method: 'POST', body: values, mode: 'cors', credentials: 'omit'})		
	}
	window.location.href='appmagavisiondesktop://magavision'	
}
